import { WorkItem, WorkItemUpdate } from '../api/workItems';

/** Raw string for Save-path equality — must match what we send to the API (no trim). */
function strOrEmpty(a: string | null | undefined): string {
    return a ?? '';
}

function normDate(a: string | null | undefined): string | null {
    if (a == null || a === '') return null;
    return a;
}

/**
 * Compares draft vs server item for fields that persist via Save (facets), excluding
 * quick-action auto-saved fields (state, needs_action, snoozed_until) and non-editable
 * values like confidence_score.
 */
export function draftFacetSaveDiffersFromItem(draft: WorkItemUpdate, item: WorkItem): boolean {
    if (
        strOrEmpty(draft.title) !== strOrEmpty(item.title) ||
        strOrEmpty(draft.summary) !== strOrEmpty(item.summary) ||
        strOrEmpty(draft.notes) !== strOrEmpty(item.notes) ||
        (draft.domain ?? 'general') !== (item.domain ?? 'general') ||
        (draft.type ?? 'INBOX') !== (item.type ?? 'INBOX') ||
        JSON.stringify(draft.tags ?? []) !== JSON.stringify(item.tags ?? [])
    ) {
        return true;
    }
    if (normDate(draft.due_date) !== normDate(item.due_date)) return true;
    if (strOrEmpty(draft.company) !== strOrEmpty(item.company)) return true;
    if (strOrEmpty(draft.job_title) !== strOrEmpty(item.job_title)) return true;
    if (strOrEmpty(draft.status) !== strOrEmpty(item.status)) return true;
    if (normDate(draft.event_date) !== normDate(item.event_date)) return true;
    if (strOrEmpty(draft.event_type) !== strOrEmpty(item.event_type)) return true;
    if ((draft.prep_days_override ?? null) !== (item.prep_days_override ?? null)) return true;
    if (JSON.stringify(draft.meta ?? {}) !== JSON.stringify(item.meta ?? {})) return true;
    return false;
}
